/* Progressive enhancement: Shopify's original description remains readable without JS. */
(() => {
  if (customElements.get('morii-product-story')) return;
  class MoriiProductStory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const doc = this.ownerDocument;
      const meaningful = node => Boolean(node.textContent.trim() || (node.nodeType === 1 && (node.matches('img,video,iframe,hr') || node.querySelector('img,video,iframe'))));
      const isHeading = node => node.nodeType === 1 && node.matches('h1,h2,h3,h4,h5,h6,.univ-title');
      const isBoldTitle = node => node.nodeType === 1 && node.matches('p') && !node.querySelector('img,video,iframe,br') && node.children.length === 1 && node.firstElementChild.matches('strong,b') && node.textContent.trim() === node.firstElementChild.textContent.trim();
      const isMedia = node => node.nodeType === 1 && (node.matches('img,video,iframe,figure,picture') || (!node.textContent.trim() && node.querySelector('img,video,iframe')));
      const blocks = [];
      // Unwrap pasted layout containers, keeping semantic blocks, links, lists and tables.
      const collect = node => {
        if (!meaningful(node)) return;
        if (node.nodeType === 1 && node.matches('div,section,article,main') && !isHeading(node)) {
          Array.from(node.childNodes).forEach(collect);
        } else if (node.nodeType === 3) {
          const p = doc.createElement('p'); p.textContent = node.textContent; blocks.push(p);
        } else if (node.nodeType === 1 && !node.matches('script,style,link,template')) blocks.push(node);
      };
      Array.from(this.childNodes).forEach(collect);
      if (!blocks.length) { this.closest('.morii-story')?.setAttribute('hidden', ''); return; }
      const groups = [];
      let current = [];
      let hasHeading = false;
      let hasBody = false;
      const flush = () => { if (current.length) groups.push(current); current = []; hasHeading = false; hasBody = false; };
      for (const node of blocks) {
        const heading = isHeading(node) || isBoldTitle(node);
        if (heading && (hasHeading || hasBody)) flush();
        // Existing image-first card markup retains the image with its following title.
        if (isMedia(node) && hasBody && blocks[0] && isMedia(blocks[0])) flush();
        current.push(node);
        if (heading) hasHeading = true;
        else if (!isMedia(node)) hasBody = true;
      }
      flush();
      const fragment = doc.createDocumentFragment();
      groups.forEach(group => {
        const card = doc.createElement('article'); card.className = 'morii-story__card';
        let copy = null;
        let mediaCount = 0;
        group.forEach(node => {
          if (isMedia(node)) {
            const media = doc.createElement('div'); media.className = 'morii-story__media';
            media.append(node); card.append(media); copy = null; mediaCount++;
            for (const image of media.querySelectorAll('img')) { image.loading = 'lazy'; image.decoding = 'async'; }
          } else {
            if (!copy) { copy = doc.createElement('div'); copy.className = 'morii-story__copy'; card.append(copy); }
            if (isHeading(node) || isBoldTitle(node)) {
              const heading = doc.createElement('h2'); heading.className = 'morii-story__title';
              const ink = doc.createElement('span'); ink.className = 'morii-story__title-ink';
              while (node.firstChild) ink.append(node.firstChild);
              heading.append(ink);
              copy.append(heading);
            } else if (node.matches('table')) {
              const scroll = doc.createElement('div'); scroll.className = 'morii-story__table'; scroll.tabIndex = 0;
              scroll.append(node); copy.append(scroll);
            } else copy.append(node);
          }
        });
        const copyCount = card.querySelectorAll(':scope > .morii-story__copy').length;
        if (mediaCount === 1 && copyCount === 1) card.classList.add('morii-story__card--split');
        if (!mediaCount) card.classList.add('morii-story__card--text');
        fragment.append(card);
      });
      this.replaceChildren(fragment);
      this.dataset.enhanced = 'true';
    }
  }
  customElements.define('morii-product-story', MoriiProductStory);
})();
